export const API_REQUEST_STATUS = {
  loading: 'loading',
  ready: 'ready',
} as const;
